import { render, staticRenderFns } from "./DashboardProducerPlan.vue?vue&type=template&id=44717788&"
import script from "./DashboardProducerPlan.vue?vue&type=script&lang=js&"
export * from "./DashboardProducerPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports